{
	"backLinkTitle": "Назад към Управление на декларации",
	"invoicedQuantity": "Фактурирано количество",
	"remainingForDeclarationCreation": "Оставащо за създаване на декларация",
	"nonTransferableAmount": "Неразпределимо количество",
	"btnCreateDeclaration": "+ Създай декларация",
	"errorMessage": "Неуспешно зареждане на детайлите за материала"
}
